import { render, staticRenderFns } from "./downLoad.vue?vue&type=template&id=47033798&"
import script from "./downLoad.vue?vue&type=script&lang=js&"
export * from "./downLoad.vue?vue&type=script&lang=js&"
import style0 from "./downLoad.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports